import { DeactivateOptionsLookup } from "constant";
import { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { Actuator } from "types/Actuator";
import { useActuatorConfigurationContext } from "context/ActuatorConfigurationContext";
import { ActuatorCommandPatchDeactivate } from "generated/models/Dashboard";

type DeactivateOptionsKey = keyof typeof DeactivateOptionsLookup;

export const RawDeactivateOptions = ({
    options,
    selectedOption,
    onChange,
}: {
    options: DeactivateOptionsKey[];
    selectedOption?: string;
    onChange: (value: ActuatorCommandPatchDeactivate) => void;
}) => {
    // Not allowing empty option selection
    useEffect(() => {
        if (!selectedOption && options[0]) {
            const optionKey = options[0];
            onChange(DeactivateOptionsLookup[optionKey]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption]);

    return (
        <>
            <hr />
            <Form.Label className="mt-3">Deactivate option</Form.Label>
            <Form.Row className="mt-4 mb-4">
                <Col>
                    <Form.Control
                        as="select"
                        custom
                        onChange={(e) => {
                            onChange(e.target.value as ActuatorCommandPatchDeactivate);
                        }}
                        value={selectedOption}
                    >
                        {options.map(
                            (o) => (
                                <option
                                    value={DeactivateOptionsLookup[o]}
                                    key={DeactivateOptionsLookup[o]}
                                >
                                    {o}
                                </option>
                            ),
                            []
                        )}
                    </Form.Control>
                </Col>
            </Form.Row>{" "}
        </>
    );
};

export const DeactivateOptions = ({ options = [] }: { options: DeactivateOptionsKey[] }) => {
    const {
        editedActuator: { deactivate },
        setEditedActuator,
    }: {
        actuator: Actuator;
        editedActuator: Actuator;
        setEditedActuator: React.Dispatch<React.SetStateAction<Actuator>>;
    } = useActuatorConfigurationContext();

    const [selectedOption, setSelectedOption] = useState(
        deactivate ?? DeactivateOptionsLookup[options[0]]
    );

    useEffect(() => {
        setEditedActuator((prevState) => ({
            ...prevState,
            deactivate: selectedOption,
        }));
    }, [selectedOption, setEditedActuator]);

    return (
        <RawDeactivateOptions
            options={options}
            selectedOption={selectedOption}
            onChange={(value) => setSelectedOption(value)}
        />
    );
};
